export default "__VITE_ASSET__CTHfelg___"